<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="'danger'"><i nz-icon nzType="py-danger" nzTheme="fill"></i></ng-container>
  <ng-container *ngSwitchCase="'warning'"><i nz-icon nzType="py-warning" nzTheme="fill"></i></ng-container>
  <ng-container *ngSwitchDefault><i nz-icon nzType="py-info-circle" nzTheme="fill"></i></ng-container>
</ng-container>
